import { twMerge } from 'tailwind-merge';
import { useThemeMode } from '@/providers/ThemeModeProvider';
import { THEME_MODES } from '@/providers/ThemeModeProvider/constants';
import { MoonIcon, SunIcon } from '@/icons';
import { classes } from './utils';

const { LIGHT, DARK } = THEME_MODES;

export default function AppearanceToggle() {
  const { mode, setMode } = useThemeMode();

  return (
    <div className={classes.wrapper}>
      <button
        className={twMerge(classes.option, mode === LIGHT && classes.active)}
        onClick={() => setMode(LIGHT)}>
        <SunIcon size="0.9rem" />
        Light
      </button>
      <button
        className={twMerge(classes.option, mode === DARK && classes.active)}
        onClick={() => setMode(DARK)}>
        <MoonIcon size="0.9rem" />
        Dark
      </button>
    </div>
  );
}
